import { render } from "./Inbox.vue?vue&type=template&id=5e358223"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"

import "./Inbox.vue?vue&type=style&index=0&id=5e358223&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__